import { TIMEZONES } from 'clipsal-cortex-utils/src/constants/timezone-states';

import {
  LongIntervalMetrologyData,
  LongPowerDataType,
  ShortIntervalMetrologyData,
  ShortPowerDataType,
} from './meter-config-types';

const ALLOWED_TZS = [
  'Australia/Sydney',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Melbourne',
  'Australia/Brisbane',
  'Australia/Perth',
  'America/Los_Angeles',
];

export const FORMATTED_TIMEZONES = TIMEZONES.filter((timezone) => ALLOWED_TZS.includes(timezone));

export const FORMATTED_TIMEZONES_FOR_SELECT = FORMATTED_TIMEZONES.map((timezone) => ({
  value: timezone,
  label: timezone,
}));

export const DATA_TYPE_TO_VALUE_SUFFIX = {
  pRealKw: 'kW',
  pReactiveKw: 'kW',
  powerFactor: '',
  current: 'Amps',
  iRMS: 'Amps',
  iRMSMin: 'Amps',
  iRMSMax: 'Amps',
  vRMS: 'Volts',
  vRMSMin: 'Volts',
  vRMSMax: 'Volts',
};

export const SHORT_DATA_TYPE_TO_TITLE_MAP: Record<ShortPowerDataType, string> = {
  pRealKw: 'Power (Real)',
  pReactiveKw: 'Power (Reactive)',
  powerFactor: 'Power Factor',
  vRMS: 'Voltage',
  iRMS: 'Current',
};

export type ShortMetrologyChartKeys = keyof Omit<
  ShortIntervalMetrologyData['readings'][0],
  'oem_meter_id' | 'oem_circuit_id' | 'energy_kwh'
>;

export const SHORT_METROLOGY_TO_SHORT_DATA_KEY_MAP: Record<ShortPowerDataType, ShortMetrologyChartKeys> = {
  pRealKw: 'power_real_kw',
  pReactiveKw: 'power_reactive_var',
  powerFactor: 'power_factor',
  vRMS: 'voltage_v',
  iRMS: 'current_a',
};

export type LongMetrologyChartKeys = keyof Omit<
  LongIntervalMetrologyData['readings'][0],
  'oem_meter_id' | 'oem_circuit_id' | 'energy_kwh'
>;

export const LONG_METROLOGY_TO_LONG_DATA_KEY_MAP: Record<LongPowerDataType, LongMetrologyChartKeys> = {
  pRealKw: 'power_real_kw',
  pReactiveKw: 'power_reactive_var',
  powerFactor: 'power_factor',
  vRMSMax: 'voltage_max_v',
  vRMSMin: 'voltage_min_v',
  iRMSMax: 'current_max_a',
  iRMSMin: 'current_min_a',
};

export const LONG_DATA_TYPE_TO_TITLE_MAP: Record<LongPowerDataType, string> = {
  pRealKw: 'Power (Real)',
  pReactiveKw: 'Power (Reactive)',
  powerFactor: 'Power Factor',
  vRMSMax: 'Voltage (Max)',
  vRMSMin: 'Voltage (Min)',
  iRMSMax: 'Current (Max)',
  iRMSMin: 'Current (Min)',
};
